import axios from "axios";
import store from '@/store'
// create an axios instance
const service = axios.create({
    timeout: 50000, // request timeout
});

// request interceptor
service.interceptors.request.use(
    (config) => {
        // console.log(config.url);
        if (store.state.app.domain) {
            config.baseURL =
                "https://" + store.state.app.domain.replace("gw.", "err.");
        }
        // Do something before request is sent
        return config;
    },
    (error) => {
        // Do something with request error
        // console.log(error) // for debug
        Promise.reject(error);
    }
);
// respone interceptor
service.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default service;